import SequencedMinigameCardLayoutGroup from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/SequencedMinigameCardLayoutGroup';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';
import PlaceholderMinigameCard from '@/game/scenes/PlaceholderStudentGameCard';

/* START OF COMPILED CODE */

import { CardDropSiteData } from '@/game/prefabs/StudentGame/CardDropSite.types';
import CardDropSite from './CardDropSite';
/* START-USER-IMPORTS */

/* END-USER-IMPORTS */

export default class SequencedCardDropSite extends CardDropSite {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // backing_2
    const backing_2 = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      832,
      160,
      4,
      4,
      4,
      4,
    );
    backing_2.visible = false;
    this.add(backing_2);

    // dropSiteCardContainer_1
    const dropSiteCardContainer_1 = scene.add.container(0, 0);
    this.add(dropSiteCardContainer_1);

    this.backing_2 = backing_2;
    this.dropSiteCardContainer_1 = dropSiteCardContainer_1;

    /* START-USER-CTR-CODE */
    this.backing = backing_2;
    this.dropSiteCardContainer = dropSiteCardContainer_1;
    /* END-USER-CTR-CODE */
  }

  public backing_2: Phaser.GameObjects.NineSlice;
  private dropSiteCardContainer_1: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  override init(data: CardDropSiteData) {
    this.layoutGroup = new SequencedMinigameCardLayoutGroup({
      parent: this.dropSiteCardContainer_1,
      elementDist: 8,
      maxCards: 6,
      origin: { x: 0, y: 0 },
      realignmentType: 'animated',
      width: data.layoutWidth,
      maxWidth: 1024,
    });

    super.init(data);

    // Initialize the placeholder card.
    this.placeholderCard = new PlaceholderMinigameCard(this.scene, 0, 0);
    this.scene.add.existing(this.placeholderCard);
    this.placeholderCard.setVisible(false);

    return this;
  }

  getLayoutGroup(): SequencedMinigameCardLayoutGroup {
    return this.layoutGroup as SequencedMinigameCardLayoutGroup;
  }

  addCard(
    card: StudentGameCard | PlaceholderMinigameCard,
    index: number,
    realignmentOverride?: 'instant' | 'animated',
  ): boolean {
    const addedCard = this.getLayoutGroup().addCard(
      card,
      index,
      realignmentOverride,
    );

    // Set the card's origin.
    if (card instanceof StudentGameCard) {
      card.origin = {
        dropSite: this,
        index: index,
      };
    }

    return addedCard || false;
  }

  removeCard(card: StudentGameCard | PlaceholderMinigameCard) {
    this.getLayoutGroup().removeCard(card);
  }

  override displayCandidatePlacement(index: number, card: StudentGameCard) {
    if (!this.placeholderCard) return;
    this.placeholderCard.setVisible(true);
    this.placeholderCard.setRepresentingMinigameCard(card);
    if (this.getLayoutGroup().findCard(this.placeholderCard)) {
      this.getLayoutGroup().moveCard(this.placeholderCard, index);
    } else {
      this.addCard(this.placeholderCard, index);
    }
  }

  override removeCandidatePlacement() {
    if (!this.placeholderCard) return;
    this.removeCard(this.placeholderCard);
    this.placeholderCard.setVisible(false);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
